import React, { createContext } from "react";
import { GlobalServiceInterface } from "../../ts/Ge";
import { DialogResult } from '../../ts/infrastructure';

export const themes = {
    light: {
        foreground: '#000000',
        background: '#eeeeee',
    },
    dark: {
        foreground: '#ffffff',
        background: '#222222',
    },
};


interface GlobalServiceInterfaceWraper {
    globalService: GlobalServiceInterface;
    iframeContext: string;
    iframeDialogSetter: Function;
    iframeDialogHandler: (result: DialogResult) => null;
}

export const globalContext = createContext<GlobalServiceInterfaceWraper>(null);

/**
 * This class performs the role of a global service discovery element, wrapped inside a React context.
 * It allows easier propagation of the high-level services, such as logger, theme, etc... without hard-coding the interfaces.
 */
export class GlobalServiceContext extends React.Component<GlobalServiceInterfaceWraper> {
    public render() {
        const { globalService, iframeContext, iframeDialogSetter, iframeDialogHandler } = this.props;

        return (
            <globalContext.Provider value={{
                globalService,
                iframeContext,
                iframeDialogSetter,
                iframeDialogHandler
            }} >
                {this.props.children}
            </globalContext.Provider>
        );
    }
}